import { MateriaInterface } from '../../../models/materia.model';
import { Component, inject, signal } from '@angular/core';
import { CrudEditComponent } from '../../../shared/components/crud/edit/edit.component';
import { ActivatedRoute } from '@angular/router';
import { MATERIAS_FIELDS_FORM_EDIT } from '../../../constants/materias.constants';
import { MateriasService } from '../../../core/materias.service';
import { NivelService } from '../../../core/nivel.service';

@Component({
  selector: 'app-materias-edit',
  imports: [CrudEditComponent],
  templateUrl: './materias-edit.component.html',
  styleUrls: ['./materias-edit.component.scss']
})
export class MateriasEditComponent {
  id = signal('');
  fields = MATERIAS_FIELDS_FORM_EDIT;
  materiasService = new MateriasService;
  materia!: MateriaInterface;
  nivelService = new NivelService;
  private activatedRoute = inject(ActivatedRoute);
  constructor() {
    this.activatedRoute.params.subscribe((params) => {
      this.id.set(params['id']);
    });
  }
  ngOnInit() {
    this.materiasService.getById(Number(this.id())).subscribe((data) => {
      this.materia = <MateriaInterface>data;
    });
    this.nivelService.getAllForSelect().subscribe((data) => {
      this.fields['nivel_id'].options = data;
    });
  }
}
